import React, { useEffect, useRef } from 'react';
import { useModal } from 'projects/components/modal/BetaModalProvider';
import { useHasAICoding } from 'hooks/feature-flags/queries';

const AIChatBetaModal = () => {
  const { openModal, closeModal, isModalOpen } = useModal();
  const { hasAICoding: featureFlagAICoding, isLoading } = useHasAICoding();

  useEffect(() => {
    // Don't do anything while loading
    if (isLoading) {
      return;
    }

    if (featureFlagAICoding === false) {
      // Only open modal once - if user closed it, don't reopen
      openModal()
    } else if (featureFlagAICoding === true) {
      closeModal();
    }
  }, [featureFlagAICoding, isLoading, openModal, closeModal, isModalOpen]);

  return <></>
};

export default AIChatBetaModal;
